import { type BaseKitchenOrderRepository } from "../../_Bases/BaseKitchenOrderRepository";
import { type LocalKitchenOrder } from "../../_Bases/BaseKitchenOrderRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBKitchenOrderRepository extends BaseIndexedDBRepository<
    LocalKitchenOrder
> implements BaseKitchenOrderRepository {
    public readonly source: InternalIndexedDBDatabase["kitchenOrders"];
    protected readonly dataTypeName = "Kitchen Order";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.kitchenOrders;
    }

    public async removeVersionsBefore(version: number): Promise<void> {
        await this.source.where("version").below(version).delete();
    }
}
